import { render, staticRenderFns } from "./comfirmModal.vue?vue&type=template&id=2cc7743e&scoped=true"
import script from "./comfirmModal.vue?vue&type=script&lang=js"
export * from "./comfirmModal.vue?vue&type=script&lang=js"
import style0 from "./comfirmModal.vue?vue&type=style&index=0&id=2cc7743e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc7743e",
  null
  
)

export default component.exports